/**
 * The platforms this build can credential from a form, rather than an OAuth round trip.
 *
 * Shared because two surfaces offer that form now — Content Repositories, and the New Target
 * wizard, which mounts the same component over itself instead of sending the admin away. A
 * fourth platform's form has to land here or the wizard silently keeps routing to the admin
 * page while the admin page starts offering it.
 */
export const LMS_CREDENTIAL_PROVIDERS = ['onpoint', 'moodle', 'acto'];

/**
 * The site address a credentialed LMS connection was made against, for prefilling its form
 * again.
 *
 * One value under three provider-specific keys — OnPoint stores `apiBaseUrl`, Moodle
 * `siteBaseUrl`, Acto `hostname` — read without branching on provider, because each form
 * takes the same answer and reads it only under its own prop name. Shared for the same reason
 * as the list above: Content Repositories and the New Target wizard both reopen these forms.
 */
export function lmsConnectionUrl(repo) {
    try {
        const params = typeof repo?.parameters === 'string'
            ? JSON.parse(repo.parameters || '{}')
            : (repo?.parameters || {});
        return params.apiBaseUrl || params.siteBaseUrl || params.hostname || '';
    } catch (e) {
        return '';
    }
}

export const LMS_OPTIONS = [
    { id: 'onpoint', displayName: 'OnPoint Digital', logoUrl: '/lms/onpoint.svg' },
    { id: 'moodle', displayName: 'Moodle', logoUrl: '/lms/moodle.svg' },
    { id: 'acto', displayName: 'Acto', logoUrl: '/lms/acto.png' },
    { id: 'saba', displayName: 'Saba', logoUrl: '/lms/saba.png' },
    { id: 'sumtotal', displayName: 'SumTotal', logoUrl: '/lms/sumtotal.png' },
    { id: 'absorb', displayName: 'Absorb', logoUrl: '/lms/absorb.png' },
    { id: 'alearning', displayName: 'Adobe Learning', logoUrl: '/lms/alearning.png' },
    // Not a connection: Cornerstone has no API MetaLark can push to. Its Edge Import reads a
    // CSV from a file store, so "connecting" it means creating a migration target whose
    // format is Cornerstone's — `targetFormat` names the family the New Target wizard opens
    // with (METALARK-1237). No Repository row is ever created for it.
    { id: 'cornerstone', displayName: 'Cornerstone', logoUrl: '/lms/cornerstone.svg', targetFormat: 'cornerstone' },
    { id: 'cypherlearning', displayName: 'Cypher Learning', logoUrl: '/lms/cypherlearning.png' },
    { id: 'docebo', displayName: 'Docebo', logoUrl: '/lms/docebo.png' },
    { id: 'dominknow', displayName: 'dominKnow', logoUrl: '/lms/dominknow.png' },
    { id: 'elblearning', displayName: 'ELB Learning', logoUrl: '/lms/elblearning.png' },
    { id: 'expertusone', displayName: 'ExpertusONE', logoUrl: '/lms/expertusone.png' },
    { id: 'intuition', displayName: 'Intuition', logoUrl: '/lms/intuition.png' },
    { id: 'learningcart', displayName: 'LearningCart', logoUrl: '/lms/learningcart.png' },
    { id: 'litmos', displayName: 'Litmos', logoUrl: '/lms/litmos.png' },
    { id: 'sapsuccessfactors', displayName: 'SAP SuccessFactors', logoUrl: '/lms/sapsuccessfactors.png' },
    { id: 'seertech', displayName: 'Seertech', logoUrl: '/lms/seertech.png' },
    { id: 'totara', displayName: 'Totara', logoUrl: '/lms/totara.png' }
];
